import { render, staticRenderFns } from "./customMenuDropdown.vue?vue&type=template&id=6b6f97f6&scoped=true"
import script from "./customMenuDropdown.vue?vue&type=script&lang=js"
export * from "./customMenuDropdown.vue?vue&type=script&lang=js"
import style0 from "./customMenuDropdown.vue?vue&type=style&index=0&id=6b6f97f6&prod&lang=scss"
import style1 from "./customMenuDropdown.vue?vue&type=style&index=1&id=6b6f97f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6f97f6",
  null
  
)

export default component.exports